import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=83154508&scoped=true&"
import script from "./DocumentDetail.vue?vue&type=script&lang=ts&"
export * from "./DocumentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDetail.vue?vue&type=style&index=0&id=83154508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83154508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83154508')) {
      api.createRecord('83154508', component.options)
    } else {
      api.reload('83154508', component.options)
    }
    module.hot.accept("./DocumentDetail.vue?vue&type=template&id=83154508&scoped=true&", function () {
      api.rerender('83154508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentDetail.vue"
export default component.exports